import React, { Component } from 'react'

export class Callus extends Component {
  render() { 
    return (

      //<!-- Cta Start -->
      <div className="section techwix-cta-section-02">
        
        <div className="container">
          {/* <!-- Cta Wrap Start --> */}
          <div className="cta-wrap" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/cta-bg.jpg)` }}>
            <div className="row align-items-center">
              <div className="col-xl-9 col-lg-8">
                {/* <!-- Cta Content Start --> */}
                <div className="cta-content">
                  <div className="cta-icon">
                    <img src={`${process.env.PUBLIC_URL}/images/cta-icon2.png`} alt="" />
                  </div>
                  <p>{this.props.callt.contactline}</p>
                </div>
                {/* <!-- Cta Content End --> */}
              </div>
              <div className="col-xl-3 col-lg-4">
                {/* <!-- Cta Button Start --> */}
                <div className="cta-btn">
                  <a className="btn btn-white" href={this.props.callt.btnlink}>{this.props.callt.btntext}</a>
                </div>
                {/* <!-- Cta Button End --> */}
              </div>
            </div>
          </div>
          {/* <!-- Cta Wrap End --> */}
        </div>
      </div>
      // <!-- Cta End -->
    )
  }
}

export default Callus